import { dataVideoFilmSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoFilmSolid = /*#__PURE__*/createIcon(dataVideoFilmSolid)
export default IconVideoFilmSolid
